import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AdminService, FilterParams } from '../_services/admin.service';
import { AdminDto, AdminResDto } from '../_dtos/adminResDto';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortHeader, MatSortModule } from '@angular/material/sort';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatPaginatorIntl, MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { AdminFormData } from '../_models/adminFormData';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOptionModule } from '@angular/material/core';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMAT } from '../_config/dateFormatConfig';
import { MatButton, MatIconButton } from '@angular/material/button';
import { AdminFilter, createDefaultFilter } from './adminFilter';
import { CatalogResDto } from '../_dtos/catalogResDto';

@Component({
  selector: 'app-admin',
  imports: [
    TranslateModule,
    MatFormField,
    MatLabel,
    MatTooltip,
    MatTableModule,
    ReactiveFormsModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    CommonModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatButton,
    MatIconButton,
    DatePipe,
    MatPaginatorModule,
    MatSortHeader,
    MatSortModule
],
  templateUrl: './admin.component.html',
  standalone: true,
  styleUrl: './admin.component.css',
  providers: [
    DatePipe,
    {
      provide: MatPaginatorIntl,
      useFactory: CustomPaginator,
      deps: [TranslateService],
    },
    {
          provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],
})
export class AdminComponent implements OnInit, AfterViewInit {

  constructor(
      private adminService: AdminService,
      private changeDetectorRef: ChangeDetectorRef,
    ) {}


  public tableDataSource = new MatTableDataSource<AdminDto>([]);
  public tableColumns: string[] = [
    'occurredAt',
    'component',
    'actorType',
    'action',
    'entityId',
    'entityDisplay',
    'runId',
    'outcome'
    
  ];
  public expandedElement: AdminDto | null = null;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public selectedRow: AdminResDto | null = null;
  public outcomes: string[] | null = null;
  public entityTypes: string[] | null = null;
  public actions: string[] | null = null;
  public components: string[] | null = null;
  public filters: AdminFilter = createDefaultFilter();
  public dataIsLoaded = false;

  public filterMenu!: FormGroup;

  public catalogData: CatalogResDto | null = null;

  public ris: AdminDto[] | null = null;
  public teams: AdminDto[] | null = null;
  public sites: AdminDto[] | null = null;
  public newResources: AdminDto[] | null = null;
  public governance: AdminDto[] | null = null;
  public bookings: AdminDto[] | null = null;
  public extensions: AdminDto[] | null = null;
  public ownerDeletions: AdminDto[] | null = null;
  public endOfLifeDeletions: AdminDto[] | null = null;
  public risSuccessCount: number | null = null;
  public risFailCount: number | null = null;
  public teamsSuccessCount: number | null = null;
  public teamsFailCount: number | null = null;
  public sitesSuccessCount: number | null = null;
  public sitesFailCount: number | null = null;
  public newResourcesSuccessCount: number | null = null;
  public newResourcesFailCount: number | null = null;
  public governanceSuccessCount: number | null = null;
  public governanceFailCount: number | null = null;
  public bookingsSuccessCount: number | null = null;
  public bookingsFailCount: number | null = null;
  public minDate = new Date();
  public maxDate = new Date();

  ngOnInit() {   
    this.getUnfilteredData()
    this.getCatalogData()
    this.initializeForm()   
  }

  ngAfterViewInit(): void {
    this.tableDataSource.paginator = this.paginator;
    this.tableDataSource.sort = this.sort;
  }

  private initializeForm() {
      this.filterMenu = new FormGroup<AdminFormData>({
        startDate: new FormControl(),
        endDate: new FormControl(),
        component: new FormControl(),
        entityType: new FormControl(),
        action: new FormControl(),
        entityId: new FormControl(),
        actorId: new FormControl(),
        actorType: new FormControl(),
        outcome: new FormControl({ value: '', disabled: true },{ nonNullable: true }),  
        severity: new FormControl(),
        runId: new FormControl(), 
        entityDisplay: new FormControl(), 
      });
      this.minDate.setDate(this.minDate.getDate() - 89);
    }

  private initializeTable(data: AdminDto[]) {
    this.tableDataSource.data = data;

    this.tableDataSource.sortingDataAccessor = (
      item: AdminDto,
      property: string,
    ): string => {
      switch (property) {
        case 'entityDisplay':
          return item.entityDisplay;

        case 'occurredAt':
          return new Date(item.occurredAt).toISOString();

        default:
          return '';
      }
    };
    this.changeDetectorRef.detectChanges();

    if (this.paginator) {
      this.tableDataSource.paginator = this.paginator;
    }

    if (this.sort) {
      this.tableDataSource.sort = this.sort;
    }
  }
    
  public getUnfilteredData() {  
      this.adminService.getEvents().subscribe({
        next: (data) => {
          this.handleApiResponse(data);
          this.getStatCardData(data);
        }
      });
    }

  private getCatalogData() {
    this.adminService.getCatalog().subscribe((data) => {
      this.catalogData = data

      this.setActions()
      this.setEntityTypes()
      this.setComponents()
    })
  }

  public setEntityTypes(){
    this.entityTypes = [
      ...new Set(
        this.catalogData?.actions.map(item => item.action.split('.')[0])
      )
    ];
  }

  public setActions(){
    this.actions = [
      ...new Set(
        this.catalogData?.actions.map(item => item.action)
      )
    ];
  }

  public setComponents() {
    this.components = [
      ...new Set(
        this.catalogData?.components
      )
    ]
  }

  public setOutcomes() {
    const entityType = this.filterMenu.get('entityType')?.value?.trim() || '';
    const outcomeControl = this.filterMenu.get('outcome');
    
    outcomeControl?.reset('');
    this.filters.outcome = '';

    if (!entityType) {
        this.outcomes = [];
        outcomeControl?.disable();
        return;
    }

    this.outcomes = [
        ...new Set(
            this.catalogData?.actions
                .filter(item => item.action.startsWith(`${entityType}.`))
                .flatMap(item => item.outcomes)
        )
    ];

    outcomeControl?.enable();
  }


  public clickedRow(row: AdminResDto): void {
      this.selectedRow = this.selectedRow === row ? null : row;
    }

  public filterSearch(filter: string) {    
    if (filter == "startDate") this.filters.startDate = this.filterMenu.get('startDate')?.value.toISOString();
    if (filter == "endDate") {
      const value = this.filterMenu.get('endDate')?.value;
      if (value) {
        const date = new Date(value);
        date.setHours(23, 59, 59, 999);

        this.filters.endDate = date.toISOString();
      }
    }  
    if (filter == "entityId") this.filters.entityId = this.filterMenu.get('entityId')?.value?.trim() || '';
    if (filter == "runId") this.filters.runId = this.filterMenu.get('runId')?.value?.trim() || '';
    if (filter == "entityDisplay") this.filters.entityDisplay = this.filterMenu.get('entityDisplay')?.value?.trim() || '';

    this.getFilteredData();
    }

  filterEvent(filter:string,event: MatSelectChange) {
    if (filter == "component") this.filters.component = event.value;
    if (filter == "entityType") this.filters.entityType = event.value;
    if (filter == "action") this.filters.action = event.value;
    if (filter == "actorId") this.filters.actorId = event.value;
    if (filter == "actorType") this.filters.actorType = event.value;
    if (filter == "outcome") this.filters.outcome = event.value;
    if (filter == "severity") this.filters.severity = event.value;

    this.getFilteredData();
  }

  public clearFilter() {
    this.filters = { 
      startDate: '',
      endDate: '',
      component:'',
      entityType:'',
      action:'',
      entityId:'',
      actorId:'',
      actorType: '',
      outcome: '',     
      severity: [] as string[],
      runId:'',
      entityDisplay: '',  
    };
    this.filterMenu.reset(this.filterMenu);
  }  

  private getFilteredData() {
      const filters: FilterParams = {};
  
      if (this.filters.startDate !== '') filters.from = this.filters.startDate;
      if (this.filters.endDate !== '') filters.to = this.filters.endDate;
      if (this.filters.component !== '') filters.component = this.filters.component;
      if (this.filters.entityType !== '') filters.entityType = this.filters.entityType;
      if (this.filters.action !== '') filters.action = this.filters.action;
      if (this.filters.entityId !== '') filters.entityId = this.filters.entityId;
      if (this.filters.actorId !== '') filters.actorId = this.filters.actorId;
      if (this.filters.actorType !== '') filters.actorType = this.filters.actorType;
      if (this.filters.outcome !== '') filters.outcome = this.filters.outcome;
      if (this.filters.severity?.length) filters.severity = this.filters.severity;
      if (this.filters.runId !== '') filters.runId = this.filters.runId;
      if (this.filters.entityDisplay !== '') filters.entityDisplay = this.filters.entityDisplay;
      
      this.adminService.getFilteredEvents(filters).subscribe({
        next: (data) => {
          this.handleApiResponse(data);
        },
      });
    }

  private handleApiResponse(data: AdminResDto) {
      this.initializeTable(data.items);
      this.dataIsLoaded = true

      if (this.paginator) {
        this.paginator.firstPage();
      }
    }

  public getStatCardData(data: AdminResDto) {
    const items = data.items
    const syncItems = items.filter(
      item => item.action === 'SyncRun.Execute'
    );
    this.ris = syncItems.filter(
      item => item.actorId?.includes('Ris')
    );
    this.teams = syncItems.filter(
      item => item.actorId?.includes('Teams')
    );
    this.sites = syncItems.filter(
      item => item.actorId?.includes('Sites')
    );
    this.newResources = items.filter(
      item => item.action.includes('Create')
    );
    this.governance = items.filter(
      item => item.action === 'GovernanceRun.Execute'
    );
    this.bookings = syncItems.filter(
      item => item.actorId?.includes('Bookings')
    );
    // Only successful ones, over all resource types
    this.extensions = items.filter(
      item => item.action.endsWith('.Extend') && item.outcome === 'Success'
    );
    // Core sends *.Delete only for deletions by an owner, the Governance only at the end of life;
    // rows removed by the Sync are *.Sync and not counted
    this.ownerDeletions = items.filter(
      item => item.action.endsWith('.Delete') && item.outcome === 'Success' && item.component === 'Core'
    );
    this.endOfLifeDeletions = items.filter(
      item => item.action.endsWith('.Delete') && item.outcome === 'Success' && item.component === 'Governance'
    );

    this.risSuccessCount = this.ris.filter(
      item => item.outcome === 'Success'
    ).length;

    this.risFailCount = this.ris.filter(
      item => item.outcome === 'Failed'
    ).length;

    this.teamsSuccessCount = this.teams.filter(
      item => item.outcome === 'Success'
    ).length;

    this.teamsFailCount = this.teams.filter(
      item => item.outcome === 'Failed'
    ).length;

    this.sitesSuccessCount = this.sites.filter(
      item => item.outcome === 'Success'
    ).length;

    this.sitesFailCount = this.sites.filter(
      item => item.outcome === 'Failed'
    ).length;

    this.newResourcesSuccessCount = this.newResources.filter(
      item => item.outcome === 'Success'
    ).length;

    this.newResourcesFailCount = this.newResources.filter(
      item => item.outcome === 'Failed'
    ).length;

    this.governanceSuccessCount = this.governance.filter(
      item => item.outcome === 'Success'
    ).length;

    this.governanceFailCount = this.governance.filter(
      item => item.outcome === 'Failed'
    ).length;

    this.bookingsSuccessCount = this.bookings.filter(
      item => item.outcome === 'Success'
    ).length;

    this.bookingsFailCount = this.bookings.filter(
      item => item.outcome === 'Failed'
    ).length;
  }


  public onStatCardClick(entity: string) {
    switch (entity) {
      case "Ris":
        this.initializeTable(this.ris!);
        break;
      case "Sites":
        this.initializeTable(this.sites!);
        break;
      case "Teams":
        this.initializeTable(this.teams!);
        break;
      case "Governance":
        this.initializeTable(this.governance!);
        break;
      case "newResources":
        this.initializeTable(this.newResources!);
        break;
      case "Bookings":
        this.initializeTable(this.bookings!);
        break;
      case "extensions":
        this.initializeTable(this.extensions!);
        break;
      case "ownerDeletions":
        this.initializeTable(this.ownerDeletions!);
        break;
      case "endOfLifeDeletions":
        this.initializeTable(this.endOfLifeDeletions!);
        break;
      default:
        break;
    }
  }
}


export function CustomPaginator(translate: TranslateService): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  const translateLabels = () => {
    paginatorIntl.itemsPerPageLabel = translate.instant(
      'PAGINATOR.ITEMS_PER_PAGE',
    );
    paginatorIntl.nextPageLabel = translate.instant('PAGINATOR.NEXT_PAGE');
    paginatorIntl.previousPageLabel = translate.instant(
      'PAGINATOR.PREVIOUS_PAGE',
    );
    paginatorIntl.firstPageLabel = translate.instant('PAGINATOR.FIRST_PAGE');
    paginatorIntl.lastPageLabel = translate.instant('PAGINATOR.LAST_PAGE');
    paginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
    ): string => {
      if (length === 0 || pageSize === 0) {
        return `0 ${translate.instant('PAGINATOR.OF')} ${length}`;
      }

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} – ${endIndex} ${translate.instant('PAGINATOR.OF')} ${length}`;
    };
  };

  translate.onLangChange.subscribe(() => {
    translateLabels();
    paginatorIntl.changes.next();
  });

  translateLabels();

  return paginatorIntl;
}
